module.exports = __webpack_public_path__ + "static/startup-b18d7a31d76891f9192f18366e815eda.svg";